import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { changeLanguage } from '../i18n'; // Import our custom helper

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const [currentLang, setCurrentLang] = useState('en');

  useEffect(() => {
    // Set initial language
    setCurrentLang(i18n?.language || 'en');

    // Set up event listener for language changes
    const handleLanguageChanged = (lng) => {
      setCurrentLang(lng);
    };

    try {
      if (i18n?.on) {
        i18n.on('languageChanged', handleLanguageChanged);
        return () => {
          i18n.off('languageChanged', handleLanguageChanged);
        };
      }
    } catch (error) {
      console.error('Error setting up language change listener:', error);
    }
  }, [i18n]);

  // Handle language change
  const handleChangeLanguage = (lng) => {
    // Use our custom helper function
    changeLanguage(lng)
      .then(() => {
        setCurrentLang(lng);
      })
      .catch((err) => {
        console.error('Error changing language:', err);
      });
  };

  return (
    <div className="language-switcher">
      <button
        className={`language-btn ${currentLang === 'en' ? 'active' : ''}`}
        onClick={() => handleChangeLanguage('en')}
      >
        EN
      </button>
      <button
        className={`language-btn ${currentLang === 'nl' ? 'active' : ''}`}
        onClick={() => handleChangeLanguage('nl')}
      >
        NL
      </button>
    </div>
  );
};

export default LanguageSwitcher;
